import React from 'react';
import '../styles/theme.css';
import '../styles/Admin.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import AdminIdentityPlate from '../components/AdminIdentityPlate';
import AdminStageVocabularyReference from '../components/AdminStageVocabularyReference';
import AdminConfigurationConsole from '../components/AdminConfigurationConsole';
/* IMPORTS */

function AdminPage() {
  return (
    <div className="ad-root">
      <div id="adminnavbarslot" className="ad-slot-adminnavbarslot">
        <Navbar activePage={"Admin"} />
      </div>
      <div id="adminidentityplate" className="ad-slot-adminidentityplate">
        <AdminIdentityPlate />
      </div>
      <div id="adminconfigurationconsole" className="ad-slot-adminconfigurationconsole">
        <AdminConfigurationConsole />
      </div>
      <div id="adminstagevocabularyreference" className="ad-slot-adminstagevocabularyreference">
        <AdminStageVocabularyReference />
      </div>
      <div id="adminfooterslot" className="ad-slot-adminfooterslot">
        <Footer />
      </div>
    </div>
  );
}

export default AdminPage;
